import { type ReactNode } from 'react';
import { BODY, Bullet, Card, Section, Stat } from './rules-typography';

export function HeroStats(): ReactNode {
  return (
    <Card>
      <div className="grid grid-cols-3 gap-base text-center">
        <Stat value="30 días" label="duración" />
        <Stat value="$40.000" label="bote total" />
        <Stat value="+$2.500" label="potencial fácil" />
      </div>
    </Card>
  );
}

function PhaseList(): ReactNode {
  return (
    <ol className={`${BODY} space-y-1.5`}>
      <Bullet>
        <strong className="text-text-primary">Collectors</strong> — crear una
        lista de 100K creadores de contenido seleccionados.
      </Bullet>
      <Bullet>
        <strong className="text-text-primary">Approachers</strong> — contactar a
        los 100K creadores de la lista.
      </Bullet>
      <Bullet>
        <strong className="text-text-primary">Magos</strong> — cerrar activación
        con los 3.333 pioneros fundadores.
      </Bullet>
    </ol>
  );
}

export function MissionPhases(): ReactNode {
  return (
    <Section title="La misión">
      <p className={BODY}>
        El nombre del juego es el objetivo: conseguir{' '}
        <strong className="text-text-primary">3.333 pioneros fundadores</strong>
        . Lo hacemos en tres fases:
      </p>
      <PhaseList />
      <p className={BODY}>
        Estás en la fase 1: 30 días para construir una lista de 100.000
        creadores intencionalmente seleccionados que cumplen los requisitos de
        Debook. De ahí saldrán los 3.333 pioneros que podrán usar Debook antes
        del lanzamiento de noviembre de 2026.
      </p>
    </Section>
  );
}

export function Perspective(): ReactNode {
  return (
    <Section title="Perspectiva del objetivo">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>21 países hispanohablantes</Bullet>
        <Bullet>500 millones de personas</Bullet>
        <Bullet>350 millones usan redes sociales activamente</Bullet>
        <Bullet>200 millones son lectores recurrentes</Bullet>
        <Bullet>
          24-50 millones son creadores de contenido (~25% de libros)
        </Bullet>
      </ul>
      <p className={BODY}>
        Buscamos solo el <strong className="text-brand-red">0,3%</strong> de los
        creadores: una fracción ridículamente pequeña. El reto no es
        encontrarlos, es <em>quién llega antes</em>.
      </p>
    </Section>
  );
}
